<template>
  <div class="py-4">
    <AboutPop :isOpen="isPopupOpen" @close="togglePopup" :data="userData" />
    <PersonalPop
      :isOpen="isPopupPersonal"
      @close="togglePopupPersonal"
      :data="userData"
    />
    <AchievePop :isOpen="isPopupAchieve" @close="togglePopupAchieve" />

    <AchievePopEdit
      :isOpen="isPopupAchieveEdit"
      @close="togglePopupAchieveEdit"
      :data="editUser"
    />

    <div class="mb-6">
      <b-card>
        <div class="flex justify-between items-center">
          <p class="font-bold text-xl text-black">About Me</p>

          <feather-icon
            icon="Edit2Icon"
            class="cursor-pointer"
            @click="isPopupOpen = true"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </div>
        <p class="mt-3" v-html="profileData[0].bios"></p>
        <div class="mt-3">
          <span v-html="aboutMe"></span>
        </div>
      </b-card>
    </div>
    <div class="mb-6">
      <b-card>
        <div class="flex justify-between items-center">
          <p class="font-bold text-xl text-black">Personal Details</p>
          <feather-icon
            icon="Edit2Icon"
            class="cursor-pointer"
            svgClasses="w-4 h-4"
            @click="isPopupPersonal = true"
          ></feather-icon>
        </div>
        <div class="mt-3 flex">
          <p class="font-semibold text-base md:w-1/5 lg:w-1/5 w-1/3 text-black">
            Location
          </p>
          <!-- <p class="px-4">:</p> -->
          <p class="font-normal">{{ location }}</p>
        </div>
        <div class="mt-2 flex">
          <p class="font-semibold md:w-1/5 lg:w-1/5 w-1/3 text-black">
            Phone no.
          </p>
          <!-- <p class="px-4">:</p> -->
          <p class="font-normal">{{ mobileNo }}</p>
        </div>
        <div class="mt-2 flex">
          <p class="font-semibold md:w-1/5 lg:w-1/5 w-1/3 text-black">Email</p>
          <!-- <p class="px-4">:</p> -->
          <p class="font-normal">{{ email }}</p>
        </div>
        <div class="mt-2 flex" v-if="userData.role !== 'volunteer'">
          <p class="font-semibold md:w-1/5 lg:w-1/5 w-1/3 text-black">
            Anonymous Mode
          </p>
          <p class="font-normal">
            <el-switch
              class="bgtoggle"
              v-model="user.isAnonymous"
              @change="hideUsername"
            >
            </el-switch>
          </p>
        </div>
        <div class="mt-2 lg:flex md:flex gap-20">
          <p class="font-semibold text-black">Disclaimer:</p>
          <p class="font-normal lg:pl-5 md:pl-5">
            By utilizing this feature, your identity will be kept confidential
            from other users within this platform, as your name will be
            concealed. Nonetheless, it is important to acknowledge that the
            administrator will have full access to your activities. We sincerely
            urge you to prioritize the community guidelines by demonstrating
            sensitivity and respect toward the diverse perspectives and values
            within this community.
          </p>
          <!-- <p class="px-4">:</p> -->
        </div>
      </b-card>
    </div>

    <div class="">
      <b-card>
        <div class="flex justify-between items-center">
          <p
            class="font-bold text-xl text-black"
            v-if="userData.role !== 'volunteer'"
          >
            Achievements
          </p>
          <p v-else class="font-bold text-xl text-black">Highlights</p>
          <div class="flex">
            <feather-icon
              icon="PlusIcon"
              class="mr-4 cursor-pointer"
              @click="isPopupAchieve = true"
              svgClasses="w-4 h-4"
            ></feather-icon>
            <!-- <feather-icon
              icon="Edit2Icon"
              class="cursor-pointer"
              @click="isPopupAchieveEdit = true"
              svgClasses="w-4 h-4"
            ></feather-icon> -->
          </div>
        </div>
        <div class="mt-3">
          <b-card
            no-body
            class="p-4 shadow-md border"
            v-for="(item, index) in achievements"
            :key="'item -' + index"
          >
            <div class="flex">
              <div class="mr-4 md:w-20 w-2/5">
                <img
                  :src="$imageURL + '/' + item.file"
                  class="w-full md:h-20 h-full object-cover"
                />
              </div>
              <div class="md:w-auto w-1/2">
                <p class="md:text-xl text-base font-bold text-black ellipsis-2">
                  {{ item.courseName }}
                </p>
                <p class="text-xs">
                  <span>Author</span
                  ><span class="ml-2">{{ item.authorName }}</span>
                </p>
                <div class="md:flex mt-0.5">
                  <p class="font-bold text-xs">
                    <span>Issue Date -</span
                    ><span class="ml-1">{{ item.issuedDate }}</span>
                  </p>
                  <p class="font-bold text-xs md:ml-2">
                    <span>Expire Date -</span>
                    <span
                      class="ml-1"
                      v-if="item.expiredDate && item.expiredDate !== 'null'"
                      >{{ item.expiredDate }}</span
                    >
                    <span class="ml-1" v-else>Lifetime</span>
                  </p>
                  <!-- <p class="font-bold text-xs md:ml-2">No Expiration Date</p> -->
                </div>
              </div>

              <div class="ml-auto flex">
                <feather-icon
                  icon="DeleteIcon"
                  class="mr-4 cursor-pointer"
                  @click="deleteAchivement(item._id)"
                  svgClasses="w-4 h-4"
                ></feather-icon>
                <feather-icon
                  icon="Edit2Icon"
                  class="cursor-pointer"
                  @click="editAchivement(item._id)"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </div>
            </div>
          </b-card>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import AboutPop from "./components/AboutMePop.vue";
import PersonalPop from "./components/PersonalPop.vue";
import AchievePop from "./components/AchievePop.vue";
import AchievePopEdit from "./components/AchieveEdit.vue";
import OldAchieveEdit from "./components/OldAchieveEdit";
import { mapState } from "vuex";
import TransactionsVue from "../../../admin/pages/campaign-list/transactions/Transactions.vue";
import { Switch } from "element-ui";

export default {
  data() {
    return {
      value1: true,
      isPopupOpen: false,
      isPopupPersonal: false,
      isPopupAchieve: false,
      isPopupAchieveEdit: false,
      editUser: {
        _id: "muid",
        userid: "userid",
      },
      isdispalyedit: false,
    };
  },
  components: {
    AboutPop,
    PersonalPop,
    AchievePop,
    AchievePopEdit,
    OldAchieveEdit,
    [Switch.name]: Switch,
  },
  methods: {
    togglePopup(val = false) {
      this.isPopupOpen = val;
    },
    togglePopupPersonal(val = false) {
      this.isPopupPersonal = val;
    },
    togglePopupAchieve(val = false) {
      this.isPopupAchieve = val;
    },
    togglePopupAchieveEdit() {
      this.isPopupAchieveEdit = !this.isPopupAchieveEdit;
    },
    handelClick(role) {
      this.isPopupPersonal = true;
    },
    async getachievement() {
      const payload = {
        userid: this.userData._id,
      };
      const data = await this.$store.dispatch(
        "achievement/getAchievement",
        payload
      );
      // console.log(data);

      //  const state = await this.$store.state.achievment

      // console.log(this.achievements);
    },

    async deleteAchivement(id) {
      this.$swal
        .fire({
          title: " Are You Sure",
          text: "You won't be able to revert this",
          icon: "Warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          CancelButtonText: "cancel8",
          CancelButtonColor: "#830c81",
          showCancelButton: true,
        })
        .then(async (result) => {
          if (result.value) {
            const payload = {
              userid: this.userData._id,
              _id: id,
            };
            const data = await this.$store.dispatch(
              "achievement/deleteAchievement",
              payload
            );

            if (data.code == 200) {
              this.$swal.fire({
                text: "Achievment Deleted Successfully",
                icon: "success",
                confirmButtonText: "Okay",
                confirmButtonColor: "#830c81",
                showconfirmButton: false,
              });
            }

            const payload2 = {
              userid: this.userData._id,
            };
            await this.$store.dispatch("achievement/getAchievement", payload2);
          }
        });
    },

    async editAchivement(id) {
      this.editUser = {
        _id: id,
        userid: this.userData._id,
      };
      this.isPopupAchieveEdit = true;
    },
    async hideUsername() {
      // let loader = this.$loading();
      let istoggled = false;
      try {
        if (this.user.isAnonymous === false) {
          this.value1 = false;
        } else if (this.user.isAnonymous === true) {
          this.value1 = true;
        }
        // console.log(this.value1, "Toggling");
        const payload = {
          _id: this.user._id,
          isAnonymous: this.value1,
        };

        await this.$store.dispatch("student/editStudents", payload);
        // loader.close();
      } catch (error) {
        console.log(error);
        // loader.close();
      }
    },
  },

  computed: {
    ...mapState("achievement", {
      achievements: "achievements",
    }),

    ...mapState("auth", ["userData"]),

    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    ...mapState("auth", {
      user: "user",
    }),

    mobileNo() {
      return this.userData.mobile;
    },
    email() {
      return this.userData.email;
    },
    aboutMe() {
      // console.log(this.userData, "*******************");
      if (this.userData.student) {
        return this.userData.student.aboutMe;
      } else {
        return this.userData.aboutMe;
      }
    },
    location() {
      if (this.userData.student) {
        return this.userData.student.location;
      } else {
        return this.userData.location;
      }
    },
    magittUrl() {
      return this.$imageURL;
    },
  },
  async mounted() {
    const payload = {
      userid: this.userData._id,
    };
    const data = await this.$store.dispatch(
      "achievement/getAchievement",
      payload
    );
    // console.log(data);
    // this.hideUsername();
    //  const state = await this.$store.state.achievment

    // console.log(this.achievements);
  },
};
</script>
<style>
.bgtoggle.el-switch.is-checked .el-switch__core {
  border-color: #4f0a4b !important;
  background-color: #4f0a4b !important;
}
</style>
